'use client';

import { classNames } from "../../../utils/styles/classNames.js";
import { transition, spaceVertical, spaceHorizontalWithoutLabel, spaceHorizontalWithoutIcon, spaceHorizontal, gaps, full, content } from "../Button.css.js";
function getAnchorContentClassNames(p) {
  return classNames(
    content,
    p.fullWidth && full,
    gaps[p.spaceType][p.size],
    !p.isLabelHidden && p.Icon && spaceHorizontal[p.spaceType][p.iconPosition][p.size],
    !p.isLabelHidden && !p.Icon && spaceHorizontalWithoutIcon[p.spaceType][p.size],
    p.isLabelHidden && spaceHorizontalWithoutLabel[p.spaceType][p.size],
    spaceVertical[p.spaceType][p.size],
    transition[p.spaceType]
  );
}
export {
  getAnchorContentClassNames
};
